"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EyeClosed = EyeClosed;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

function EyeClosed(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("path", {
    d: "M12 19c-.842 0-1.685-.178-2.504-.495M20.882 12.468C18.99 15.967 15.495 19 12 19M19.079 8.921c.69.805 1.295 1.68 1.803 2.612a.987.987 0 010 .935M5 19L19 5M9.773 14.227a3.15 3.15 0 114.455-4.455",
    stroke: "#1F2D27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), (0, _core.jsx)("path", {
    d: "M17.044 6.956C15.497 5.759 13.748 5 12 5c-3.495 0-6.99 3.033-8.882 6.533a.987.987 0 000 .935c.946 1.749 2.292 3.381 3.838 4.577",
    stroke: "#1F2D27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

EyeClosed.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EyeClosed"
};